import { memo, useMemo } from "react";
import { useRosterFocusStore } from "@/store/rosterFocusStore";
import { cn } from "@/utils/cn";
import type { PrevTailData } from "@/hooks/roster-craete/useRosterPrevTail";
import {
  type RosterTableLayoutConfig,
  getBodyScheduleDayStripOffsetPx,
  type RosterTableLayout,
} from "./rosterColumnHoverLayout";

export type RosterColumnHoverBackdropProps = {
  daysInMonth: number;
  hasPrevTail: boolean;
  prevTailData?: PrevTailData | null;
  layout?: RosterTableLayout;
  layoutConfig?: RosterTableLayoutConfig;
};

export const RosterColumnHoverBackdrop = memo(
  function RosterColumnHoverBackdrop({
    daysInMonth,
    hasPrevTail,
    prevTailData,
    layout = "create",
    layoutConfig,
  }: RosterColumnHoverBackdropProps) {
    const hoveredColumn = useRosterFocusStore((state) => state.hoveredColumn);
    const selectedColumn = useRosterFocusStore((state) => state.selectedColumn);

    const colKeys = useMemo(
      () =>
        Array.from({ length: daysInMonth }, (_, i) => `day${i + 1}` as const),
      [daysInMonth]
    );
    const scheduleStripOffsetPx = getBodyScheduleDayStripOffsetPx(
      hasPrevTail ? prevTailData : null,
      layout,
      layoutConfig
    );

    return (
      <div
        className={cn(
          "pointer-events-none absolute top-0 bottom-0 -z-10 flex h-full"
        )}
        style={{ left: scheduleStripOffsetPx }}
        data-roster-days-in-month={daysInMonth}
        aria-hidden
      >
        {colKeys.map((colKey) => {
          const isSelected = selectedColumn === colKey;
          const isHovered = hoveredColumn === colKey;
          return (
            <div
              key={colKey}
              data-column={colKey}
              className="flex h-full w-[34px] shrink-0 flex-col"
            >
              <div
                className="h-full w-full"
                style={{
                  backgroundColor: isSelected
                    ? "rgba(169, 223, 254, 0.4)"
                    : isHovered
                      ? "rgba(169, 223, 254, 0.3)"
                      : "transparent",
                }}
              />
            </div>
          );
        })}
      </div>
    );
  }
);
